/*********************************************************
 *                  Admin liste user Ctrl
 *
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("DbExplorationCtrl", ["$http", "$scope", "toastr","ExploitationService","ENV","AdminClientsService", "clients", "configurationProperties", function ($http, $scope, toastr,ExploitationService,ENV,AdminClientsService, clients, configurationProperties) {
		$scope.data = {
			clients: clients.data,
			search:{},
			chouetteDataToDisplay:[],
			tiamatDataToDisplay:[],
			prefix: "MOBIITI"
		};

		if (configurationProperties.status === 200 && angular.isArray(configurationProperties.data) && configurationProperties.data.length) {
			let prefixProperty = configurationProperties.data.find(item => item.key === "super_identifier_prefix");
			if (prefixProperty) {
				$scope.data.prefix = prefixProperty.value;
			}
		}

		if (clients.data.length > 0) {
			$scope.selectedClient = clients.data[0];
		}


		$scope.launchDBSearch = function (search) {
			$scope.data.chouetteDataToDisplay = [];
			$scope.data.tiamatDataToDisplay = [];

			if (countSearchParameters(search) > 1){
				toastr.error("Un seul attribut peut être recherché à la fois. Veuillez saisir un id de quai OU de stopPlace OU un imported-id", "Erreur");
				return;
			}

			if (search.quayId != undefined ){
				lauchQuayIdSearch(search);
			}

			if (search.stopPlaceId != undefined ){
				lauchStopPlaceIdSearch(search);
			}

			if (search.importedId != undefined && search.importedId != "" ){
				lauchImportedIdSearch(search);
			}

		};

		function countSearchParameters(search){
			let nbOfParameters = 0;

			if (search.quayId != undefined ){
				nbOfParameters = nbOfParameters + 1;
			}

			if (search.stopPlaceId != undefined ){
				nbOfParameters = nbOfParameters + 1;
			}

			if (search.importedId != undefined && search.importedId != ""){
				nbOfParameters = nbOfParameters + 1;
			}
			return nbOfParameters;

		}

		function lauchImportedIdSearch(search) {
			ExploitationService.getStopAreaFromOriginalStopId(search.importedId).then((response) => {
				const data = response.data;
				data.forEach(element => addToChouetteDataToDisplay(element));
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur chouette");
			});


			let currentRef = AdminClientsService.getCurrentReferential();

			getImportedIdInfoFromTiamat(currentRef , search.importedId).then((response) => {
				$scope.data.tiamatDataToDisplay = response.data;
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur récupération tiamat " + currentRef +", " +  search.importedId);
			});
		}

		function lauchStopPlaceIdSearch(search) {
			ExploitationService.getStopAreaFromMobiitiCode($scope.data.prefix + ":StopPlace:"+search.stopPlaceId).then((response) => {
				addToChouetteDataToDisplay(response.data);
				retrieveChildsForId(response.data.id);

			}).catch((error) => {
				toastr.error(error.data.message, "Erreur");
			});

			getStopPlaceInfoFromTiamat($scope.data.prefix + ":StopPlace:" + search.stopPlaceId).then((response) => {
				$scope.data.tiamatDataToDisplay = response.data;
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur récupération tiamat " + $scope.data.prefix + ":StopPlace:" + search.stopPlaceId);
			});

		}

		function retrieveChildsForId(parentId) {
			ExploitationService.getStopAreaByParentId(parentId).then((response) => {
				const data = response.data;
				if (data != null && data.length > 0){
					data.forEach(child => addToChouetteDataToDisplay(child));
				}

			}).catch((error) => {
				toastr.error(error.data.message, "Erreur recup " + $scope.data.prefix + ":StopPlace:" + parentId);
			});


		}


		function lauchQuayIdSearch(search) {
			ExploitationService.getStopAreaFromMobiitiCode($scope.data.prefix + ":Quay:"+search.quayId).then((response) => {
				const data = response.data;
				if (data === ""){
					toastr.error("point non trouvé : " + $scope.data.prefix + ":Quay:"+search.quayId , "Erreur");
					return;
				}
				addToChouetteDataToDisplay(data);
				let parentObjectId = data.commercial_object_id;
				$scope.findParent(parentObjectId);
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur");
			});


			getQuayInfoFromTiamat($scope.data.prefix + ":Quay:"+search.quayId).then((response) => {
				$scope.data.tiamatDataToDisplay = response.data;
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur récupération tiamat");
			});

		}


		$scope.findParent = function (parentObjectId) {
			ExploitationService.getStopAreaFromMobiitiCode(parentObjectId).then((response) => {
				addToChouetteDataToDisplay(response.data);
			}).catch((error) => {
				toastr.error(error.data.message, "Erreur récupération parent");
			});

		};


		function addToChouetteDataToDisplay(objectToDisplay) {

			if (objectToDisplay == null || objectToDisplay == undefined || objectToDisplay === ""){
				return ;
			}

			let newChouetteData = {};
			newChouetteData.id = objectToDisplay.id;
			newChouetteData.objectId = objectToDisplay.objectId;
			newChouetteData.areaType = objectToDisplay.area_type;
			newChouetteData.latitude = objectToDisplay.latitude;
			newChouetteData.longitude = objectToDisplay.longitude;
			newChouetteData.name = objectToDisplay.name;
			newChouetteData.originalStopId = objectToDisplay.originalStopId;
			newChouetteData.parentObjectId = objectToDisplay.commercial_object_id;
			$scope.data.chouetteDataToDisplay.push(newChouetteData);


		}


		function getQuayInfoFromTiamat(quayNetexIdParam) {
			return $http.get(ENV.TIAMAT_BASE_URL + "netex/getQuayInfo", {
				params: {
					quayNetexId: quayNetexIdParam
				}

			});
		}

		function getStopPlaceInfoFromTiamat(stopPlaceNetexIdParam) {
			return $http.get(ENV.TIAMAT_BASE_URL + "netex/getStopPlaceInfo", {
				params: {
					stopPlaceNetexId: stopPlaceNetexIdParam
				}

			});
		}

		function getImportedIdInfoFromTiamat(referential , importedId) {
			return $http.get(ENV.TIAMAT_BASE_URL + "netex/getImportedIdInfo", {
				params: {
					referential: referential,
					importedId: importedId
				}

			});
		}

	}]);

